import React, { FunctionComponent, useState, ChangeEvent } from 'react';

type Props = {
  className?: string;
  placeholder?: string;
  isNecessary?: boolean;
  label: string;
  annotation?: string;
  width?: string;
  name: string;
  type?: string;
  onChanged: (name: string, value: string) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  className,
  placeholder,
  isNecessary,
  label,
  annotation,
  width,
  name,
  type,
  onChanged,
}) => {
  const [internalValue, setInternalValue] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    if (name === 'firstName') {
      setFirstName(value);
    } else if (name === 'lastName') {
      setLastName(value);
    } else {
      setInternalValue(value);
    }

    onChanged(name, value);
  };

  return (
    <label htmlFor={name} className={className}>
      <span className="label--title">{label}</span>
      {isNecessary && <span className="label--necessary">必須</span>}

      {name === 'name' ? (
        <div className="label--flex">
          <input
            name="lastName"
            type="text"
            className={`label--input ${width}`}
            placeholder="（姓）高野"
            value={lastName}
            onChange={handleChange}
            required
          />
          <input
            name="firstName"
            type="text"
            className={`label--input ${width}`}
            placeholder="（名）聡司"
            value={firstName}
            onChange={handleChange}
            required
          />
        </div>
      ) : (
        <input
          name={name}
          type={type}
          className={`label--input ${width}`}
          placeholder={placeholder}
          value={internalValue}
          onChange={handleChange}
          minLength={name === 'password' ? 6 : undefined}
          required={isNecessary}
        />
      )}

      {annotation !== '' && <p className="label--annotation">{annotation}</p>}
    </label>
  );
};
